import axios from 'axios';

// Same convention as src/new_version/api/Events.jsx: business is resolved
// server-side from the JWT (verifyToken -> req.businessId), so none of
// these calls need to pass a business id — the dashboard never talks to
// Momentus directly, only to this backend.
const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class MomentusFetchAPI {
    //Function to read the (secret-masked) Momentus config/status for the current business
    static async getConfig(token) {
        const res = await server(`/momentus/config`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to force a real connection test against Momentus
    static async testConnection(token) {
        const res = await server(`/momentus/test-connection`, {
            method: 'POST',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to list Momentus events for the configured Venue (Room is never required here)
    static async getEvents(token, { startDate, endDate } = {}) {
        const params = new URLSearchParams();
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        const query = params.toString() ? `?${params.toString()}` : '';
        const res = await server(`/momentus/events${query}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to search Momentus events by name/external id/unique number — this is what feeds the event-link search box
    static async searchEvents(token, searchText) {
        const params = new URLSearchParams({ search: searchText });
        const res = await server(`/momentus/events?${params.toString()}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to get the current Momentus link for a SmartPay event, if any
    static async getEventLink(event_id, token) {
        const res = await server(`/momentus/events/${event_id}/link`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to link a SmartPay event to a Momentus event
    static async linkEvent(event_id, data, token) {
        const res = await server(`/momentus/events/${event_id}/link`, {
            method: 'POST',
            headers: { 'x-access-token': token },
            data
        });
        return res;
    }

    //Function to unlink a SmartPay event from Momentus
    static async unlinkEvent(event_id, token) {
        const res = await server(`/momentus/events/${event_id}/link`, {
            method: 'DELETE',
            headers: { 'x-access-token': token }
        });
        return res;
    }
}
